<template>
    <div class="modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="block block-rounded block-transparent mb-0">
                    <div class="block-header block-header-default">
                        <h3 class="block-title">Upload Files</h3>
                        <div class="block-options">
                            <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                                <i class="fa fa-fw fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div class="block-content fs-sm">
                        <div class="mb-4">
                            <label for="formFileMultiple" class="form-label">Select Files To Upload</label>
                            <input class="form-control" type="file" id="formFileMultiple" multiple ref="file-upload-input" v-on:change="processFiles">
                        </div>

                        <table v-if="files.length" class="table mb-4" style="table-layout:fixed">
                            <thead>
                                <tr>
                                    <th style="width:50%">Name</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(file, index) in files" :key="index">
                                    <td v-if="file.uuid === false">
                                        <span style="text-overflow:ellipsis;overflow:hidden;display:block;white-space:nowrap;">
                                            {{ file.rawFile.name }}
                                        </span>
                                    </td>
                                    <td v-if="file.uuid === false">
                                        <p v-if="file.errors.length">
                                            {{ file.errors.join(', ') }}
                                        </p>
                                        <div v-else class="progress push" style="height:10px;width:100%;">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" :style="{ width: file.uploadPercentage + '%'}" :aria-valuenow="file.uploadPercentage" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </td>
                                    <td v-if="file.uuid !== false" colspan="2">
                                        <div class="input-group">
                                            <input type="text" class="form-control" v-model="file.title" :placeholder="file.rawFile.name" v-on:change="updateTitle(index)">
                                            <span v-if="file.loading !== null" class="input-group-text">
                                                <div v-if="file.loading === true" class="spinner-border spinner-border-sm text-primary" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                                <i v-else class="fa fa-check"></i>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="block-content block-content-full text-end bg-body">
                        <button type="button" class="btn btn-sm btn-alt-secondary me-1" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Modal from 'bootstrap/js/dist/modal';
import { Eventbus } from '@/components/eventbus';

export default {
    props: {
        routes: Object,
    },
    data () {
        return {
            files: []
        };
    },
    mounted () {
        this.modal = new Modal(this.$el);

        Eventbus.on('add-classics-file', () => {
            this.modal.show();
        });
    },
    methods: {
        processFiles () {
            for (let file of this.$refs['file-upload-input'].files) {
                this.files.push({
                    uuid: false,
                    title: '',
                    errors: [], // this is out of use now but could be neat in the future
                    loading: null,
                    rawFile: file,
                    uploadPercentage: 0,
                });
                this.processFile(this.files.length - 1);
            }
            // clear the input so its not confusing
            this.$refs['file-upload-input'].value = '';
        },
        async processFile (index) {
            let file = this.files[index].rawFile;

            let uploadDetails;

            try {
                uploadDetails = await axios.post(
                    this.routes.getUploadUrl,
                    {
                        name: file.name,
                        size: file.size,
                    }
                ).then(({ data }) => data);
            } catch (error) {
                let status = 'Unknown';
                if (error.response) {
                    if (error.response.data && error.response.data.errors) {
                        status = error.response.data.errors[0].join(', ');
                    } else {
                        status = error.response.status;
                    }
                }

                Swal.fire({
                    icon: 'error',
                    title: 'Could not upload file ' + file.name,
                    text: 'System error: ' + status,
                });

                // abort upload
                return;
            }

            let data = new FormData();
            for (let key in uploadDetails.inputs) {
                data.append(key, uploadDetails.inputs[key]);
            }
            data.append('key', uploadDetails.destination)
            data.append('file', file);

            let success = false;

            await axios.post(
                uploadDetails.action,
                data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: (progressEvent) => {
                        this.files[index].uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                    }
                }
            ).then(() => {
                success = true;
            }).catch((error) => {
                let status = 'Unknown';
                if (error.response) {
                    status = error.response.status;
                }
                Swal.fire({
                    icon: 'error',
                    title: 'Could not upload file ' + file.name,
                    text: 'System error: ' + status,
                });
            });

            if (success) {
                axios.post(
                    this.routes.completeUpload,
                    {
                        'internalSignature': uploadDetails.internalSignature
                    }
                ).then((response) => {
                    this.files[index].uuid = response.data.fileUuid;
                    Eventbus.emit('files-table-refresh');
                }).catch((error) => {
                    let status = 'Unknown';
                    if (error.response) {
                        status = error.response.status;
                    }
                    Swal.fire({
                        icon: 'error',
                        title: 'Could not upload file',
                        text: 'System error: ' + status,
                    });
                });
            }
        },
        updateTitle (index) {
            this.files[index].loading = true;
            axios.post(
                this.routes.updateTitle.replace('replace-me', this.files[index].uuid),
                {
                    title: this.files[index].title
                }
            ).then((response) => {
                this.files[index].loading = false;
                Eventbus.emit('files-table-refresh');
            }).catch((error) => {
                let status = 'Unknown';
                if (error.response) {
                    status = error.response.status;
                }
                Swal.fire({
                    icon: 'error',
                    title: 'Could not update title',
                    text: 'System error: ' + status,
                });
            });
        }
    }
}
</script>
